export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const SET_USER = 'SET_USER';
export const UPDATE_USER = 'UPDATE_USER';
